import { Modal } from 'antd'
import React from 'react'

type Props = {
    open:any,
    onCancel:any,
    redirectUrl:any
}

const LoginModal = (props: Props) => {
    const {open, onCancel, redirectUrl} = props;
  return (
    <>
    <Modal
        title="Please Register or Sign In to continue.."
        open={open}
        onOk={()=> window.open(`https://www.notablehq.com/login/?redirect_to=${encodeURIComponent(redirectUrl)}&reauth=1`, "_blank")}
        okText="Login/Register"
        onCancel={onCancel}
        closeIcon={false}
        style={{ top: '30%' }}
        // okButtonProps={{ disabled: true }}
        // cancelButtonProps={{ disabled: true }}
      >
        <p>To access this feature, you need to be logged in. If you already have an account,
        please login. If you don't have an account, you can sign up for free.</p>
      </Modal>
    </>
  )
}

export default LoginModal